/**
 * Created by felipe on 7/22/24.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('quizzingReportStudent', {
                parent: 'site',
                url: '/quizzing/:collectionId/:assetId/:quizId/student/report/:isPreview/:showResyncButton',
                params: {
                },
                data: {
                    roles: [],
                    pageTitle: 'quizzing.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/quizzing/templates/quizzing-student-report.html',
                        controller: 'QuizzingStudentReportController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('quizzing');
                        return $translate.refresh();
                    }]
                }
            });
    });
